import { StepName } from '|/app/services';

// Each hook stub returns null (not started / unknown).
// Replace with real implementation when building per-step partial completion.

export const useBAVPartialCompletion = (_stepId: StepName): string | null => null;
export const useIncomePartialCompletion = (_stepId: StepName): string | null => null;
export const useAddressPartialCompletion = (_stepId: StepName): string | null => null;
export const useTradeVerificationPartialCompletion = (_stepId: StepName): string | null => null;
export const useAdditionalIncomePartialCompletion = (_stepId: StepName): string | null => null;
